<template>
  <div class="print">
    <div class="contents">
      <div class="title">
        <span>안 전 보 건 총 괄 책 임 자<span class="mx-6"></span>선 임 서</span>
      </div>

      <div class="userInfo">
        <p>소 속 : {{ form.소속명 }}</p>
        <p>직 책 : {{ form.직책 }}</p>
        <p>성 명 : {{ form.성명 }}</p>
      </div>

      <div class="message">
        <p class="mb-8">&nbsp; 위 사람을 산업안전보건법 제62조 제1항 및 시행령 제53조【안전보건 총괄책임자의 직무 등】에 의거 안전보건 업무를 총괄 관리할 안전보건 총괄책임자로 선임하오니, 아래 업무를 충실히 수행하여 주시기 바랍니다.</p>
        <p class="mt-8 mb-5">※ 안전보건총괄책임자의 업무내용</p>
        <p>1. 법 제36조에 따른 위험성평가의 실시에 관한 사항</p>
        <p>2. 법 제51조 및 제54조에 따른 작업의 중지</p>
        <p>3. 법 제64조에 따른 도급 시 산업재해 예방조치치</p>
        <p>4. 법 제72조제1항에 따른 산업안전보건관리비의 관계수급인 간의 사용에 관한 협의·조정 및 그 집행의 감독</p>
        <p>5. 안전인증대상기계등과 자율안전확인대상기계등의 사용 여부 확인</p>
      </div>

      <div class="sign">
        <div class="yyyyMMdd p-8">
          <span class="year pr-6">{{ new Date(form.선임일).format("yyyy") }} 년</span>
          <span class="month pr-6">{{ new Date(form.선임일).format("MM") }} 월</span>
          <span class="day">{{ new Date(form.선임일).format("dd") }} 일</span>
        </div>

        <div class="body">{{ hostTitle }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Print297",
  props: {
    border: Object,
    form: Object,
  },
  computed: {
    hostTitle() {
      const host = window.location.hostname;

      switch (host) {
        case "bsgs.maot.co.kr":
          return "강서구청장";
        case "gsnd.maot.co.kr":
          return "경상남도청장";
        case "ep.maot.co.kr":
          return "은평구청장";
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.print {
  padding: 2rem 1rem;

  & > .contents {
    display: grid !important;
    width: 100%;
    height: auto;

    border: 1px solid #cdcdcd;

    padding: 2rem;
  }
}
.title {
  padding-top: 2rem;
  padding-bottom: 2rem;
  margin-bottom: 2rem;

  display: grid;
  align-items: center;
  justify-content: center;

  font-size: 3rem;
  font-weight: bold;
}

.userInfo {
  display: grid;
  justify-content: flex-end;
  margin-bottom: 1.25rem;

  & > p {
    width: 400px;

    font-size: 1.5rem;
    font-weight: 500;

    padding: 1rem 0;
    margin-bottom: 1rem;
  }
}

.message {
  p {
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 3.125rem;

    &.sub {
      padding-left: 1.5rem;
      font-size: 1.375rem;
      font-weight: 400 !important;
      line-height: 2.875rem;
    }
  }
}

.sign {
  padding-top: 80px;

  display: grid;
  justify-content: center;

  .yyyyMMdd {
    display: flex;
    justify-content: center;
    font-size: 1.6875rem;

    margin-bottom: 4rem;
  }

  .body {
    font-size: 48px;
    font-weight: 700;
    color: #3c3c3c;
    text-align: center;
    line-height: 2.75rem;
    margin-bottom: 80px;
  }

  .etc {
    margin-top: 2rem;
    text-align: center;

    font-size: 1.125rem;
    color: #3c3c3c;
    line-height: 2rem;
    text-decoration: underline;
  }
}
</style>
